import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { COUNTRY_CODES } from '../constants/countries.js';
extendZodWithOpenApi(z);
export const UpdateProfileSchema = z
    .object({
    name: z.string().max(200).trim().min(1, 'Name cannot be empty').optional().openapi({
        description: "User's display name (single field — see helpers in @formency/shared)",
        example: 'Jane Smith',
    }),
    mobile: z.string().max(20).trim().optional().openapi({
        description: 'Mobile phone number',
        example: '+61412345678',
    }),
    country: z.enum(COUNTRY_CODES).optional().openapi({
        description: 'ISO 3166-1 alpha-2 country code',
        example: 'AU',
    }),
    learnerOnboardingCompleted: z.boolean().optional().openapi({
        description: 'Whether the learner has completed the onboarding flow',
        example: true,
    }),
    timezone: z.string().max(50).trim().nullable().optional().openapi({
        description: 'IANA timezone identifier',
        example: 'Australia/Sydney',
    }),
    weekStartsOn: z.enum(['monday', 'sunday']).optional().openapi({
        description: 'Which day the learner considers the start of the week',
        example: 'monday',
    }),
})
    .strict()
    .openapi('UpdateProfile');
//# sourceMappingURL=profile.schema.js.map